var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-block-wrap',{attrs:{"block-name":"课程详情"}},[_c('ueditor-display',{attrs:{"html":_vm.courseDetail.describe}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }